import FactorHealthBadgeTooltip from './FactorHealthBadgeTooltip'

export default FactorHealthBadgeTooltip
